import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import ProgressBar from 'components/Widgets/ProgressBar';
import IconWithText from 'components/Widgets/IconWithText';
import SubmitButton from 'components/Widgets/SubmitButton';

import Actions from './Actions';

export default function CompanyInformation({ affiliate, nextUrl, prevUrl }) {
  const formSchema = Yup.object().shape({
    affiliateType: Yup.string().typeError('Type is required'),
  });

  const onSave = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      affiliate.id,
      {
        company_name: values.companyName,
        affiliate_type: values.affiliateType,
      },
      () => {
        setSubmitting(false);
        Actions.goToPage(nextUrl);
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <div className="content">
      <section>
        <Row>
          <Col md={8}>
            <h1 className="mb-3">Tell us about yourself</h1>

            <IconWithText
              iconClassName="onboarding-company-data-icon big-icon bg-secondary"
            >
              <h5>Part 2: Company information</h5>
              What is the name of the Affiliate Company?
            </IconWithText>
          </Col>

          <Col md={4} className="mt-3 mt-md-0">
            <ProgressBar now={50} />
          </Col>
        </Row>
      </section>

      <Formik
        validationSchema={formSchema}
        initialValues={{
          companyName: affiliate.attributes.company_name,
          affiliateType: affiliate.attributes.affiliate_type,
        }}
        onSubmit={onSave}
      >
        {({ values, isSubmitting }) => (
          <FormikForm className="form-with-counter" noValidate="">
            <section className="border-top border-light">
              <Row>
                <Col md={{ span: 8, offset: 2 }}>
                  <HorizontalSelectField
                    className="select-counter-form"
                    name="affiliateType"
                    label="Are you an independent affiliate or work for an insurance brokerage?"
                    options={[
                      { value: 'broker', label: 'I am a broker.' },
                      { value: 'independent', label: 'I am an independent affiliate.' },
                    ]}
                    required
                  />

                  {values.affiliateType === 'broker' && (
                    <HorizontalTextField name="companyName" label="Company" />
                  )}
                </Col>
              </Row>
            </section>

            <footer className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                disabled={isSubmitting}
                onClick={() => { Actions.goToPage(prevUrl); }}
              >
                Previous
              </Button>

              <SubmitButton loading={isSubmitting}>
                Next
              </SubmitButton>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
}

CompanyInformation.propTypes = {
  affiliate: PropTypes.object.isRequired,
  nextUrl: PropTypes.string.isRequired,
  prevUrl: PropTypes.string.isRequired,
};
